import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { getViewModeSearchParam, fetchAppData, fetchTPASettings } from '@wix/communities-blog-client-common';

import fetchFeedPosts from '../../../app/actions/fetch-feed-posts';
import { setDemoMode } from '../../../app/actions/set-demo-mode';
import { setExperiments } from '../../../app/actions/set-experiments';
import { setUser } from '../../../app/actions/set-user';
import { setViewMode } from '../../../app/actions/set-view-mode';
import { setSearchParams } from '../../../app/actions/set-search-params';
import { setAppLoaded } from '../../../app/actions/app-loaded';
import * as appLifecycleService from '../../../app/services/app-lifecycle-service';
import AppWrapper from '../../../app/components/app-wrapper';
import AccessibilityListener from '../../../app/components/accessibility-listener';
import RecentPosts from '../../components/recent-posts';
import { getFeedPosts } from '../../../app/selectors/post-selectors';
import fedopsLogger from '../../services/fedops-logger';
import styles from './widget.scss';

const POSTS_PER_PAGE = 3;

class Widget extends Component {
  static fetchData = ({ store, searchParams, user, demoMode, experiments, query }) => {
    const lang = query.lang ? query.lang : null;
    const promises = [
      store.dispatch(setSearchParams(searchParams)),
      store.dispatch(setViewMode(getViewModeSearchParam(store.getState()))),
      store.dispatch(fetchTPASettings()),
      store.dispatch(fetchAppData()),
      store.dispatch(
        fetchFeedPosts({
          lang,
          page: 1,
          pageSize: POSTS_PER_PAGE,
          excludeContent: true,
        }),
      ),
      store.dispatch(setDemoMode(Boolean(demoMode))),
      store.dispatch(setExperiments(experiments)),
    ];
    if (user) {
      promises.push(store.dispatch(setUser(user)));
    }
    return promises;
  };

  componentDidMount() {
    appLifecycleService.appLoaded();
    this.props.setAppLoaded();
    fedopsLogger.appLoaded();
  }

  render() {
    const { posts } = this.props;
    return (
      <AppWrapper id="content-wrapper" className={classNames(styles.widget, 'blog-background-color')}>
        <AccessibilityListener />
        <RecentPosts posts={posts} />
      </AppWrapper>
    );
  }
}

Widget.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.object),
  setAppLoaded: PropTypes.func,
};

const mapStateToProps = (state) => ({
  posts: getFeedPosts(state),
});

export default connect(mapStateToProps, { setAppLoaded })(Widget);
